
import SEO from '../components/SEO';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <SEO
        title="Página no encontrada - NEO"
        description="La página que buscas no existe. Regresa al inicio de NEO para continuar tu experiencia de transformación personal."
        canonical="/404"
        ogTitle="Página no encontrada - NEO"
        ogDescription="La página que buscas no existe. Regresa al inicio de NEO para continuar tu experiencia de transformación personal."
        ogType="website"
        ogUrl="/404"
        twitterTitle="Página no encontrada - NEO"
        twitterDescription="La página que buscas no existe. Regresa al inicio de NEO."
      />
      
      <div className="text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-300 mb-4">404</h1>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Página no encontrada</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-md mx-auto">
            Lo sentimos, la página que buscas no existe o ha sido movida.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link 
            to="/" 
            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-[#6607a5] to-purple-700 hover:from-purple-700 hover:to-[#6607a5] text-white font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            <i className="ri-home-line mr-2"></i>
            Volver al inicio
          </Link>
        </div>
        
        <div className="mt-12 text-gray-500">
          <p>¿Necesitas ayuda? Contacta con nosotros</p>
        </div>
      </div>
    </div>
  );
}
